import { useState } from "react";
import NavItemOption from "interfaces/NavItemOption";
import { useHistory } from "react-router";
import SubNavMenuePopover from "../navigation-bar/SubNavMenuePopover";

export default function PriorityNavItem({
  text,
  isActive,
  children,
  route,
  itemId,
  isNavbarReadyToDisplay,
}: NavItemOption & { isNavbarReadyToDisplay: boolean }) {
  const history = useHistory();
  const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);

  const handleNavItemClick = () => {
    if (children?.length) {
      setIsSubMenuVisible((prevState) => !prevState);
    } else if (route) {
      history.push(route);
    }
  };

  const getActiveStateClass = () => {
    return isActive ? "bg-primaryRed bg-opacity-35 text-black" : "";
  };

  return (
    <>
      <div
        id={`priority-nav-item-${itemId}`}
        className={`${isNavbarReadyToDisplay ? "flex-grow" : "inline-block"} 
        py-2 px-4 font-semibold rounded-lg text-center cursor-pointer ${getActiveStateClass()} ${
          isSubMenuVisible ? "text-black" : ""
        } ${!isActive && !isSubMenuVisible ? "text-promGray2" : ""}`}
        onClick={handleNavItemClick}
        data-text={text}
      >
        <div className="nav-item-text">{text}</div>
      </div>
      {children && children.length > 0 && isSubMenuVisible && (
        <SubNavMenuePopover
          menuItems={children}
          target={`#priority-nav-item-${itemId}`}
          onClose={() => setIsSubMenuVisible(false)}
          onSelect={() => setIsSubMenuVisible(false)}
          yOffset={25}
        />
      )}
    </>
  );
}
